import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-complete-bar',
    templateUrl: './complete-bar.component.html',
    styleUrls: ['./complete-bar.component.scss'],
    standalone: false
})
export class CompleteBarComponent {
     @Input() public step!: number;
     @Input() public totalSteps!: number;

     width: string = '5%'
     widthAria: string = '5'

     constructor(){
     }

     ngOnInit(){
          this.width = (Math.floor((this.step/this.totalSteps)*100)).toString() + "%";
          this.widthAria = (Math.floor((this.step/this.totalSteps)*100)).toString();
     }
}
